import { Controller } from '@hotwired/stimulus'

export default class ConstructionObjectFormController extends Controller {
  static targets = ['sendToSrs', 'vedludbTokenContainer']

  toggle(event) {
    if (!this.hasVedludbTokenContainerTarget) return

    this.vedludbTokenContainerTarget.classList.toggle('d-none', !event.target.checked)
  }
}
